import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { User, Album, Media } from '../services/api';

interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  setAuth: (user: User, token: string) => void;
  clearAuth: () => void;
}

interface UIState {
  currentAlbum: Album | null;
  selectedMedia: Media | null;
  isSlideshowOpen: boolean;
  isVideoFilterActive: boolean;
  setCurrentAlbum: (album: Album | null) => void;
  setSelectedMedia: (media: Media | null) => void;
  setSlideshowOpen: (open: boolean) => void;
  setVideoFilterActive: (active: boolean) => void;
}

interface CacheState {
  albums: Album[];
  mediaCache: Record<string, { media: Media[]; pagination: any }>;
  setAlbums: (albums: Album[]) => void;
  setMediaCache: (albumId: string, data: { media: Media[]; pagination: any }) => void;
  clearCache: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      setAuth: (user, token) => set({ user, token, isAuthenticated: true }),
      clearAuth: () => set({ user: null, token: null, isAuthenticated: false }),
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({ user: state.user, token: state.token, isAuthenticated: state.isAuthenticated }),
    }
  )
);

export const useUIStore = create<UIState>((set) => ({
  currentAlbum: null,
  selectedMedia: null,
  isSlideshowOpen: false,
  isVideoFilterActive: false,
  setCurrentAlbum: (album) => set({ currentAlbum: album }),
  setSelectedMedia: (media) => set({ selectedMedia: media }),
  setSlideshowOpen: (open) => set({ isSlideshowOpen: open }),
  setVideoFilterActive: (active) => set({ isVideoFilterActive: active }),
}));

export const useCacheStore = create<CacheState>((set) => ({
  albums: [],
  mediaCache: {},
  setAlbums: (albums) => set({ albums }),
  setMediaCache: (albumId, data) => set((state) => ({
    mediaCache: { ...state.mediaCache, [albumId]: data }
  })),
  clearCache: () => set({ albums: [], mediaCache: {} }),
}));






